export default "__VITE_ASSET__f7c7d7a3__"